<script lang="ts">
  import { Heading, Paragraph, Button } from '../components';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;
  export let light = false;
  export let narrow = false;
  export let wide = false;
  export let fullWidth = false;
  export let short = false;
  export let centered = false;

  $: properties = {
    ...properties,
    backgroundColor: properties.backgroundOverlayColor,
  };
  $: ({ borderRadius, generalSettings } = settings);
  $: ({ heading, button, text: description } = properties);
</script>

<div
  class="content"
  class:narrow
  class:wide
  class:centered
  class:short
  class:full-width={fullWidth}
>
  <div class="stars">
    {#each Array(5) as _}
      <img
        class="star"
        src="https://voolt-template-asset.s3.amazonaws.com/template-4/images/star.svg"
        loading="lazy"
        alt=""
      />
    {/each}
  </div>

  {#if heading.length}
    <Heading
      type={'h1'}
      css="margin-top:10px;margin-bottom:15px;color:{light
        ? '#fff'
        : 'var(--vlt-lp-primary)'};"
    >
      {@html heading}
    </Heading>
  {/if}

  {#if description.length}
    <Paragraph
      css="margin-bottom:30px;color:{light ? '#fff' : 'var(--vlt-lp-text)'};"
    >
      {@html description}
    </Paragraph>
  {/if}

  {#if properties.isCustom || !generalSettings?.callToAction?.value}
    <Button
      {borderRadius}
      buttonType={button.link_type}
      buttonLink={button.link}
      buttonTitle={button.label}
    />
  {:else}
    <Button
      {borderRadius}
      buttonType="Section"
      buttonLink="form"
      buttonTitle={generalSettings?.callToAction?.value === 'book-internal' ||
      generalSettings?.callToAction?.value === 'book-external'
        ? 'Book An Appointment'
        : generalSettings?.callToAction?.value}
    />
  {/if}
</div>

<style lang="scss">
  .content {
    max-width: 700px;
    text-align: left;
  }

  .content.narrow {
    max-width: 500px;
  }

  .content.wide {
    max-width: 950px;
  }

  .content.full-width {
    max-width: unset;
    width: 100%;
  }

  .content.centered {
    margin: 0 auto;
    text-align: center;
  }

  .stars {
    display: inline-flex;
    grid-gap: 6px;
    align-items: center;
    justify-content: start;
    margin: 0 auto;
  }

  .content.centered .stars {
    justify-content: center;
  }

  .star {
    height: 20px;
    width: 20px;
  }

  @media screen and (max-width: 1080px) {
    .content {
      max-width: 600px;
    }

    .content.narrow {
      max-width: 400px;
    }

    .content.full-width {
      max-width: unset;
      width: 100%;
    }
  }

  @media screen and (max-width: 865px) {
    .content {
      max-width: unset;
      z-index: 3;
    }

    .content:not(.short) {
      padding: 70px 0px;
    }

    .content.full-width {
      width: 100%;
    }
  }
</style>
